var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCrowdenergy203(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.2 99.2",
    style: {
      enableBackground: "new 0 0 99.2 99.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#c8d1c5",
    d: "M56.9,69.9c-0.6,0-1,0.4-1,1h0c0,1.7-0.7,3.3-1.8,4.4c-1.1,1.1-2.7,1.8-4.4,1.8c-1.7,0-3.3-0.7-4.4-1.8 c-1.1-1.1-1.8-2.7-1.8-4.4c0-0.6-0.4-1-1-1c-0.6,0-1,0.4-1,1c0,4.6,3.7,8.2,8.2,8.2c4.6,0,8.2-3.7,8.2-8.2 C57.9,70.3,57.4,69.9,56.9,69.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8d1c5",
    d: "M73.5,67.2c0,0-0.1-0.1-0.2-0.4c-0.4-0.8-1.6-3-2.6-5.3c-0.5-1.1-1.1-2.3-1.5-3.4c-0.4-1.1-0.8-2-0.9-2.6 l-1,0.2l1-0.2c-0.3-1.4-0.5-3.1-0.5-4.9c0-1.8,0.1-3.5,0.2-4.8c0.1-0.6,0.1-1.2,0.2-1.5c0-0.2,0-0.3,0.1-0.4c0-0.1,0-0.1,0-0.1 l0-0.1c0-8.6-5.9-15.9-13.8-18c0-0.2,0.1-0.4,0.1-0.7c0-2.7-2.2-4.9-4.9-4.9c-2.7,0-4.9,2.2-4.9,4.9c0,0.2,0,0.4,0.1,0.7 c-8,2.1-13.8,9.4-13.8,18l0,0.1c0,0,0,0,0,0.1c0.1,0.7,0.4,3.6,0.4,6.7c0,1.8-0.1,3.6-0.4,4.9c-0.1,0.7-0.5,1.8-1.1,3 c-0.8,1.9-1.8,4-2.7,5.7c-0.4,0.8-0.8,1.6-1.1,2.1c-0.3,0.5-0.4,0.8-0.4,0.8c-0.2,0.3-0.2,0.7,0,1s0.5,0.5,0.9,0.5h46.1 c0.4,0,0.7-0.2,0.9-0.5C73.7,67.9,73.7,67.6,73.5,67.2z M29.9,63.4c0.6-1.3,1.3-2.7,1.8-4c0.5-1.3,1-2.5,1.2-3.4 c0.3-1.6,0.5-3.5,0.5-5.4c0-3.4-0.4-6.5-0.4-7c0-8,5.7-14.7,13.2-16.3c0.3-0.1,0.5-0.2,0.7-0.5c0.1-0.3,0.2-0.6,0.1-0.8 c-0.1-0.3-0.2-0.7-0.2-1c0-0.8,0.3-1.5,0.9-2.1c0.5-0.5,1.3-0.9,2.1-0.9c0.8,0,1.5,0.3,2.1,0.9c0.5,0.5,0.9,1.3,0.9,2.1 c0,0.3-0.1,0.7-0.2,1c-0.1,0.3-0.1,0.6,0.1,0.8s0.4,0.4,0.7,0.5c7.5,1.6,13.2,8.2,13.2,16.2c-0.1,0.5-0.5,3.7-0.5,7.1 c0,1.8,0.1,3.7,0.5,5.4l0,0c0.2,0.9,0.7,2.1,1.2,3.4c1.1,2.6,2.6,5.5,3.5,7.3H28.2C28.7,65.8,29.3,64.7,29.9,63.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCrowdenergy203);
export default __webpack_public_path__ + "static/media/icons-crowdenergy-203.897fdcd587c662880152c28ff6504143.svg";
export { ForwardRef as ReactComponent };